var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqGeneralGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_889_76335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.5C11.04 4.5 6 9.54 6 15.75C6 21.96 11.04 27 17.25 27H19.5V30.45C24.96 27 28.5 21.33 28.5 15.75C28.5 9.54 23.46 4.5 17.25 4.5ZM18.75 24.75H15.75V21.75H18.75V24.75ZM18.75 19.5H15.75C15.75 14.625 20.25 15 20.25 12C20.25 10.35 18.9 9 17.25 9C15.6 9 14.25 10.35 14.25 12H11.25C11.25 8.685 13.935 6 17.25 6C20.565 6 23.25 8.685 23.25 12C23.25 15.75 18.75 16.125 18.75 19.5Z",
    fill: "#F9FCEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 1.5C9.39 1.5 3 7.89 3 15.75C3 23.355 8.985 29.595 16.5 29.985V35.385L18.645 34.35C26.34 30.645 31.5 23.175 31.5 15.75C31.5 7.89 25.11 1.5 17.25 1.5ZM19.5 30.45V27H17.25C11.04 27 6 21.96 6 15.75C6 9.54 11.04 4.5 17.25 4.5C23.46 4.5 28.5 9.54 28.5 15.75C28.5 21.345 24.96 27.015 19.5 30.45ZM15.75 21.75H18.75V24.75H15.75V21.75ZM17.25 6C13.935 6 11.25 8.685 11.25 12H14.25C14.25 10.35 15.6 9 17.25 9C18.9 9 20.25 10.35 20.25 12C20.25 15 15.75 14.625 15.75 19.5H18.75C18.75 16.125 23.25 15.75 23.25 12C23.25 8.685 20.565 6 17.25 6Z",
    fill: "#A9CF3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_889_76335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqGeneralGreen);
export default __webpack_public_path__ + "static/media/faq-general-green.99090e581c66550781eb3f75099d108c.svg";
export { ForwardRef as ReactComponent };